
import type { SetupContext } from 'vue'
import type { PropType } from 'vue/types/options'
import type { ExplainMessages } from '../../models/i18n/explain.messages'

import { defineComponent, getCurrentInstance, ref } from 'vue'

import ExplainExportCsvButton from '../../components/explain/explain-export-csv-button.component.vue'

import EpbAside from '../aside.component.vue'
import { EpbSelect, EpbSwitch, EpbText } from '../shared'

export default defineComponent({
  name: 'ExplainExportAside',
  components: {
    EpbAside,
    EpbSelect,
    EpbSwitch,
    EpbText,
    ExplainExportCsvButton,
  },
  props: {
    messages: {
      type: Object as PropType<ExplainMessages['exportability']>,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    isBrowseContext: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, ctx: SetupContext) {
    const { emit } = ctx
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const switchMessages = $epb.messages.app.switch

    const baseClass = 'epb-export-aside'

    const options = [{ value: '100' }, { value: '500' }, { value: '1000' }, { value: '1250' }]

    const opened = ref(false)

    const numberOfProductsSelected = ref(options[0].value)

    const hasConfidentialData = ref(true)

    const isDownloaded = ref(false)

    function downloadSucceedEvent(succeed: boolean): void {
      isDownloaded.value = succeed
    }

    const close = (): void => {
      opened.value = false
      isDownloaded.value = false
      emit('close')
    }

    const open = (): void => {
      opened.value = true
      emit('open')
    }

    return {
      opened,
      close,
      downloadSucceedEvent,
      baseClass,
      hasConfidentialData,
      switchMessages,
      isDownloaded,
      numberOfProductsSelected,
      options,
      open,
    }
  },
})
